(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = {
      root: '[data-best-sellers]',
      tab: '.best-sellers__tab',
      panel: '.best-sellers__panel',
    };

    const initBestSellers = (container) => {
      if (!container || container.dataset.bestSellersReady === 'true') return;

      const tabs = Array.from(container.querySelectorAll(selectors.tab));
      const panels = Array.from(container.querySelectorAll(selectors.panel));

      if (!tabs.length || !panels.length) return;

      const setActiveTab = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          setActiveTab(Number(tab.dataset.tabIndex || 0));
        });
      });

      container.dataset.bestSellersReady = 'true';

      const initialIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
      setActiveTab(initialIndex >= 0 ? initialIndex : 0);
    };

    const initAllBestSellers = (scope = document) => {
      scope.querySelectorAll(selectors.root).forEach(initBestSellers);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllBestSellers(), { once: true });
    } else {
      initAllBestSellers();
    }

    document.addEventListener('shopify:section:load', (event) => initAllBestSellers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-persistent-cart"] && !Shopify.designMode) return;
  try {
    
  /* ------------------------------------------------------------------------------------
     ADD TO BOX FLIES TO THE BAG. Charlie, 20 Sep 2026: "Adding product on BAB still needs
     the product moving to the cart animation."

     IT TOUCHES NEITHER cart-controller.js NOR product-form.js. Those two are the single add
     boundary and have been through a dozen review rounds; an animation has no business
     inside them. This is a delegated listener that watches for the click and draws over the
     top - if it throws, breaks or is deleted, the add is completely unaffected.

     NO NEW REQUEST. The ghost copies `currentSrc` off the card's own <img>, which the
     browser has already downloaded and decoded, so the flight costs no bytes.

     This block compiles into the global compiled_assets/scripts.js, so it is scoped by the
     `.ctr-perma-cart-container` check rather than by where it is written.
     ------------------------------------------------------------------------------------ */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('.integrated-add-to-cart-btn');
      if (!trigger || !trigger.closest('.ctr-perma-cart-container')) return;

      // The customer asked for less movement. The add still happens; only the flight goes.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const card = trigger.closest('.product-grid__item');
      const image = card && card.querySelector('img');
      const bag = document.querySelector('.header-actions__cart-icon');
      if (!image || !bag) return;

      const from = image.getBoundingClientRect();
      const to = bag.getBoundingClientRect();
      // A zero rect means the bag is off screen or the card is mid-render. Nothing to fly to.
      if (!from.width || !from.height || !to.width) return;

      const ghost = document.createElement('img');
      ghost.src = image.currentSrc || image.src;
      ghost.alt = '';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.style.cssText =
        'position:fixed;left:0;top:0;pointer-events:none;z-index:2147482000;' +
        'object-fit:contain;border-radius:12px;' +
        'width:' + from.width + 'px;height:' + from.height + 'px;';
      document.body.appendChild(ghost);

      const scale = Math.max(0.14, Math.min(0.38, (to.width * 0.9) / from.width));
      // Scaling happens about the element's centre, so the landing translate puts the
      // UNSCALED box's centre on the bag's centre - using the scaled half-width here is the
      // easy way to land it off by a few pixels.
      const endX = to.left + to.width / 2 - from.width / 2;
      const endY = to.top + to.height / 2 - from.height / 2;

      const flight = ghost.animate(
        [
          { transform: 'translate(' + from.left + 'px,' + from.top + 'px) scale(1)', opacity: 1 },
          {
            transform:
              'translate(' + (from.left + endX) / 2 + 'px,' +
              (Math.min(from.top, endY) - 46) + 'px) scale(' + (1 + scale) / 2 + ')',
            opacity: 0.95,
            offset: 0.55,
          },
          { transform: 'translate(' + endX + 'px,' + endY + 'px) scale(' + scale + ')', opacity: 0.15 },
        ],
        { duration: 620, easing: 'cubic-bezier(.35,.02,.35,1)', fill: 'forwards' }
      );

      const clear = () => ghost.remove();
      flight.addEventListener('finish', clear);
      flight.addEventListener('cancel', clear);
      // Belt and braces: a tab backgrounded mid-flight never fires `finish`, and a ghost
      // left behind is a full-size product photo pinned over the page.
      setTimeout(clear, 1500);
    },
    true
  );

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-header-banners"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("alpine:init", () => {
    Alpine.data("headerBanners", function () {
        return {
            init() {
                const banners = this.$el.querySelectorAll('[data-banner]');
                banners.forEach(banner => {
                    const destination = banner.dataset.destinationSelector;
                    const destinationElements = document.querySelectorAll(destination);

                    if (banner && destinationElements) {
                        destinationElements.forEach(destinationElement => {
                            destinationElement.appendChild(banner.cloneNode(true));
                        });
                    }
                });
            }
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSliderComponent extends HTMLElement {
    connectedCallback() {
      this.init();
      /* THIS THREW ON EVERY HOMEPAGE LOAD FOR 24 DAYS.

         It read:
           this.boundSectionLoad = this.handleSectionLoad.bind(this);
           document.addEventListener('shopify:section:load', this.boundSectionLoad);

         `handleSectionLoad` is never defined - not here, not in any commit since this
         component arrived in the R19 snapshot on 11 Aug 2026. So `this.handleSectionLoad`
         was undefined and `.bind` threw
         "Uncaught TypeError: Cannot read properties of undefined (reading 'bind')",
         which is exactly what the live homepage console shows.

         IT THREW *AFTER* init(), which is why nothing looked broken: autoplay, swipe and
         the pause control all work. What did NOT happen is the two lines below it - the
         throw aborted connectedCallback before they ran, so shopify:block:select and
         shopify:block:deselect were NEVER attached and clicking a slide in the theme
         editor did not preview that slide.

         The listener is deleted rather than repaired. It was redundant: a custom element
         is re-upgraded automatically when Shopify swaps the section HTML, so the new
         element's own connectedCallback runs and the old one disconnects. There was
         nothing for the handler to do.

         The remaining two are stored on `this` so disconnectedCallback can actually
         remove them - bound inline they produced a new function object every time and
         removeEventListener silently matched nothing, leaking a listener per re-render in
         the editor. */
      this.boundBlockSelect = this.handleBlockSelect.bind(this);
      this.boundBlockDeselect = this.handleBlockDeselect.bind(this);
      document.addEventListener('shopify:block:select', this.boundBlockSelect);
      document.addEventListener('shopify:block:deselect', this.boundBlockDeselect);
    }

    disconnectedCallback() {
      this.clearTimer();
      document.removeEventListener('shopify:block:select', this.boundBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.boundBlockDeselect);
      document.removeEventListener('visibilitychange', this.boundVisibility);
      if (this.motionQuery && this.boundMotionChange) {
        this.motionQuery.removeEventListener('change', this.boundMotionChange);
      }
    }

    init() {
      this.track = this.querySelector('.hero-slider__track');
      this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
      this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
      this.nextBtn = this.querySelector('.hero-slider__arrow--next');
      this.playPauseBtn = this.querySelector('.hero-slider__play-pause');
      this.currentIndex = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;

      /* The visible pause control was removed 3 Sep 2026 (Charlie: "autoplay with just
         swipe abaility"), so this is the only remaining concession to WCAG 2.2.2:
         anyone whose OS asks for reduced motion gets no autoplay at all.

         CORRECTION 3 Sep 2026: the first version of this read .matches ONCE here and a
         comment claimed a mid-session change was honoured. It was not - there was no
         listener. Codex caught it. The listener below makes the claim true; flipping the
         OS setting now stops or starts rotation without a reload.

         It is NOT a WCAG 2.2.2 mechanism on its own - Codex is explicit that
         prefers-reduced-motion, swipe and hover-suspension are not substitutes for a
         generally perceivable control, and auto-updating content has no five-second
         exception. See the comment beside the removed button in the markup above. */
      this.motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      if (this.motionQuery && this.motionQuery.matches) {
        this.autoplayEnabled = false;
      }
      if (this.motionQuery && !this.boundMotionChange) {
        this.boundMotionChange = (e) => {
          if (e.matches) {
            this.autoplayEnabled = false;
            this.clearTimer();
          } else if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
            this.autoplayEnabled = true;
            if (!this.isPaused) this.scheduleNext();
          }
        };
        this.motionQuery.addEventListener('change', this.boundMotionChange);
      }
      this.loop = this.dataset.loop === 'true';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.isPaused = false;
      this.timer = null;

      if (window.Shopify && window.Shopify.designMode) {
        this.autoplayEnabled = false;
      }

      if (this.track) this.track.style.transform = 'translateX(0%)';

      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.playPauseBtn) {
        // Autoplay can be off at runtime even though Liquid rendered the button -
        // reduced motion, or the theme editor. A pause control with nothing to pause is
        // worse than none, so hide it rather than leave it inert.
        if (!this.autoplayEnabled) this.playPauseBtn.hidden = true;
        this.playPauseBtn.addEventListener('click', () => this.togglePlay());
      }
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.pause(true); this.goTo(i); }));

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.next();
        if (e.key === 'ArrowLeft') this.prev();
      });

      this.setupSwipe();

      if (this.pauseOnHover) {
        // LATENT, not live - pause_on_hover is false on the homepage today, which is the
        // only reason this has never been seen. It is the same defect as the swipe one
        // fixed in e6f702a: pause(false) sets isPaused = true unconditionally, so the
        // `if (!this.isPaused) this.resume()` on mouseleave could never run and the first
        // hover killed rotation for the session. Remember the state and only restart if
        // the visitor had not deliberately paused.
        this.addEventListener('mouseenter', () => {
          this.hoverWasPaused = this.isPaused;
          this.clearTimer();
        });
        this.addEventListener('mouseleave', () => {
          if (!this.hoverWasPaused && !this.isPaused) this.scheduleNext();
        });
      }

      this.boundVisibility = () => {
        if (document.hidden) {
          this.clearTimer();
        } else if (!this.isPaused) {
          this.scheduleNext();
        }
      };
      document.addEventListener('visibilitychange', this.boundVisibility);

      this.setAttribute('data-initialized', 'true');

      if (this.autoplayEnabled) {
        this.scheduleNext();
        this.restartDotProgress();
      }
    }
    
    setupSwipe() {
      if (!this.track || this.slides.length <= 1) return;

      let startX = 0;
      let startY = 0;
      let isSwiping = false;

      const onStart = (e) => {
        const point = e.touches ? e.touches[0] : e;
        startX = point.clientX;
        startY = point.clientY;
        isSwiping = true;
      };

      const onMove = (e) => {
        if (!isSwiping) return;
        const point = e.touches ? e.touches[0] : e;
        const deltaX = point.clientX - startX;
        const deltaY = point.clientY - startY;

        if (Math.abs(deltaX) > Math.abs(deltaY) && e.cancelable) {
          e.preventDefault();
        }
      };

      const onEnd = (e) => {
        if (!isSwiping) return;
        isSwiping = false;

        const point = e.changedTouches ? e.changedTouches[0] : e;
        const deltaX = point.clientX - startX;
        const deltaY = point.clientY - startY;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        /* A swipe navigates and lets autoplay carry on. It used to stop rotation for
           the rest of the session: pause(false) sets isPaused = true unconditionally
           (see pause() below), so the `if (!this.isPaused) this.resume()` that followed
           could never fire. Found by Codex 3 Sep 2026, after the visible pause control
           was removed and swipe became the only navigation - which is what made a
           silent permanent stop matter.

           clearTimer() rather than pause(): it cancels the pending advance so the new
           slide gets a full duration, without touching isPaused. If the visitor has
           genuinely paused, that is respected and nothing restarts. */
        const wasPaused = this.isPaused;
        this.clearTimer();

        if (deltaX < 0) {
          this.next();
        } else {
          this.prev();
        }

        if (!wasPaused) this.scheduleNext();
      };

      this.track.addEventListener('touchstart', onStart, { passive: true });
      this.track.addEventListener('touchmove', onMove, { passive: false });
      this.track.addEventListener('touchend', onEnd);
      this.track.addEventListener('touchcancel', () => { isSwiping = false; });
    }

    handleBlockSelect(e) {
      const idx = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
      if (idx > -1) {
        this.pause(false);
        this.goTo(idx);
      }
    }

    handleBlockDeselect() {
      if (window.Shopify && window.Shopify.designMode) return;
      if (!this.isPaused) this.resume();
    }

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    scheduleNext() {
      this.clearTimer();
      if (!this.autoplayEnabled || this.isPaused || this.slides.length <= 1) return;
      const duration = parseInt(this.slides[this.currentIndex].dataset.duration, 10) || 5000;
      this.timer = setTimeout(() => this.next(), duration);
    }

    goTo(index) {
      if (!this.slides[index] || index === this.currentIndex) return;
      const current = this.slides[this.currentIndex];
      const next = this.slides[index];

      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');

      if (this.track) this.track.style.transform = `translateX(-${index * 100}%)`;

      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('is-active');
        this.dots[this.currentIndex].setAttribute('aria-selected', 'false');
      }
      if (this.dots[index]) {
        this.dots[index].classList.add('is-active');
        this.dots[index].setAttribute('aria-selected', 'true');
      }

      this.currentIndex = index;
      this.scheduleNext();
      this.restartDotProgress();
    }

    next() {
      let nextIndex = this.currentIndex + 1;
      if (nextIndex >= this.slides.length) {
        if (!this.loop) {
          this.pause(false);
          return;
        }
        nextIndex = 0;
      }
      this.goTo(nextIndex);
    }

    prev() {
      let prevIndex = this.currentIndex - 1;
      if (prevIndex < 0) {
        if (!this.loop) return;
        prevIndex = this.slides.length - 1;
      }
      this.goTo(prevIndex);
    }

    pause(userInitiated) {
      this.isPaused = true;
      this.clearTimer();
      const activeFill = this.dots[this.currentIndex]?.querySelector('.hero-slider__dot-ring-fill');
      if (activeFill) activeFill.style.animationPlayState = 'paused';
      if (userInitiated) this.setPlayPauseUI(false);
    }

    resume() {
      this.isPaused = false;
      this.setPlayPauseUI(true);
      this.scheduleNext();
      this.restartDotProgress();
    }

    togglePlay() {
      if (this.isPaused) this.resume();
      else this.pause(true);
    }

    restartDotProgress() {
      if (!this.autoplayEnabled) return;
      const duration = parseInt(this.slides[this.currentIndex].dataset.duration, 10) || 5000;
      this.dots.forEach((dot, i) => {
        const fill = dot.querySelector('.hero-slider__dot-ring-fill');
        if (!fill) return;
        fill.style.animation = 'none';
        fill.style.animationPlayState = '';
        if (i === this.currentIndex) {
          // eslint-disable-next-line no-unused-expressions
          void fill.offsetWidth;
          fill.style.animation = `hero-slider-dot-progress ${duration}ms linear forwards`;
        }
      });
    }

    setPlayPauseUI(isPlaying) {
      if (!this.playPauseBtn) return;
      const iconPause = this.playPauseBtn.querySelector('.icon-pause');
      const iconPlay = this.playPauseBtn.querySelector('.icon-play');
      // setAttribute, NOT the .hidden property. `hidden` is an IDL attribute on
      // HTMLElement and an <svg> is an SVGElement, so `svgEl.hidden = true` silently
      // sets a JS expando and never touches the attribute. Measured: after clicking
      // pause, aria-label flipped to "Play slideshow" while the pause bars stayed
      // visible and the play triangle stayed hidden - the control lied about its own
      // state in both directions.
      const setHidden = (el, on) => {
        if (!el) return;
        if (on) el.setAttribute('hidden', '');
        else el.removeAttribute('hidden');
      };
      setHidden(iconPause, !isPlaying);
      setHidden(iconPlay, isPlaying);
      this.playPauseBtn.setAttribute('aria-pressed', String(!isPlaying));
      this.playPauseBtn.setAttribute('aria-label', isPlaying ? 'Pause slideshow' : 'Play slideshow');
    }
  }

  if (!customElements.get('hero-slider-component')) {
    customElements.define('hero-slider-component', HeroSliderComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
